module.exports = __webpack_public_path__ + "static/media/singaporelog.ab0c2802.png";